import * as React from "react";
import { IBackdrop } from "src/ScrollyInterface";
import "./Backdrop.scss";

const backdrop = (props: IBackdrop) => {
  const { children, clicked, show } = props;
  return show ? (
    <div className="Backdrop" onClick={clicked}>
      {children}
    </div>
  ) : null;
};
export default backdrop;



// WEBPACK FOOTER //
// ./src/UI/Backdrop.tsx